module.exports = __webpack_public_path__ + "img/kite.be5030ca.webp";